import { Routes } from 'components';
import routes from './Dashboard.routing';

export default () => <Routes routes={routes} />;
